import { httpService } from './httpService';

export interface ForgotPasswordDto {
    email: string;
}

export interface ForgotPasswordResponse {
    success: boolean;
    message: string;
}

export interface ResetPasswordDto {
    token: string;
    email: string;
    newPassword: string;
}

export interface ResetPasswordResponse {
    success: boolean;
    message: string;
}

class ForgotPasswordService {
    private static readonly baseEndpoint = "/api/Account";

    async forgotPassword(email: string): Promise<void> {
        try {
             await httpService.post(
                `${ForgotPasswordService.baseEndpoint}/forgot-password`,
                { email } as ForgotPasswordDto,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
        } catch (error) {
            console.error("Forgot password service error:", error);
            throw error; 
        }
    }

    async resetPassword(resetData: ResetPasswordDto): Promise<void> {
        try {
            await httpService.post(
                `${ForgotPasswordService.baseEndpoint}/reset-password`,
                resetData,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            // If 200 OK, it will reach here
        } catch (error) {
            console.error("Reset password service error:", error);
            throw error; // Let caller decide what to show
        }
    }
}

export const forgotPasswordService = new ForgotPasswordService();